﻿import {setOptions} from "@googlemaps/js-api-loader";

export async function Create(apiKey: string, id: string, lat: number, lng: number): Promise<google.maps.Map> {
    console.log('OmMap.Create. apiKey:' + apiKey + ' id: ' + id + ' lat: ' + lat + ' lng: ' + lng);

    setOptions({
        key: apiKey,
    });


    const {Map} = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const {AdvancedMarkerElement} = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    let element = document.getElementById(id) as HTMLElement;

    const map = new Map(element, {
        center: {lat: lat, lng: lng},
        zoom: 12,
        mapId: 'DEMO_MAP_ID'
    });

    new AdvancedMarkerElement({
        map: map,
        position: {lat: lat, lng: lng},
    });

    return map;
}

export default {
    Create
};
